export default {
  'app.setting.pagestyle': 'Настройка стиля страницы',
  'app.setting.pagestyle.dark': 'Темный стиль',
  'app.setting.pagestyle.light': 'Светлый стиль',
  'app.setting.content-width': 'Ширина содержимого',
  'app.setting.content-width.fixed': 'Фиксированная',
  'app.setting.content-width.fluid': 'Жидкая',
  'app.setting.themecolor': 'Цвет темы',
  'app.setting.themecolor.dust': 'Пыльный красный',
  'app.setting.themecolor.volcano': 'Вулкан',
  'app.setting.themecolor.sunset': 'Закатный оранжевый',
  'app.setting.themecolor.cyan': 'Циан',
  'app.setting.themecolor.green': 'Полярный зеленый',
  'app.setting.themecolor.daybreak': 'Рассветный синий (по умолчанию)',
  'app.setting.themecolor.geekblue': 'Гик-синий',
  'app.setting.themecolor.purple': 'Золотая фиалка',
  'app.setting.navigationmode': 'Режим навигации',
  'app.setting.sidemenu': 'Макет бокового меню',
  'app.setting.topmenu': 'Макет верхнего меню',
  'app.setting.fixedheader': 'Фиксированный заголовок',
  'app.setting.fixedsidebar': 'Фиксированная боковая панель',
  'app.setting.fixedsidebar.hint': 'Работает с макетом бокового меню',
  'app.setting.hideheader': 'Скрыть заголовок при прокрутке',
  'app.setting.hideheader.hint': 'Работает когда включено скрытие заголовка',
  'app.setting.othersettings': 'Другие настройки',
  'app.setting.weakmode': 'Режим для дальтоников',
  'app.setting.copy': 'Копировать настройки',
  'app.setting.copyinfo': 'копирование успешно, пожалуйста, замените defaultSettings в src/models/setting.js',
  'app.setting.production.hint':
    'Панель настроек показывается только в среде разработки, пожалуйста, измените вручную',
};
